import Button from "@components/ui/button";
import { CardFooter } from "@components/ui/card";
import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";
import { useCallback } from "react";
import { toast } from "react-toastify";
import { useUpdateFolderMutation } from "@/shared/services";
import { useMoveFolderCtx } from "../ctx";

export const MoveFolderFooter = () => {
  const { folderId, loading, setLoading, folder, folderData } =
    useMoveFolderCtx();
  const dispatch = useAppDispatch();
  const { mutateAsync: updateFolder } = useUpdateFolderMutation();

  const close = useCallback(() => {
    if (loading) return;
    dispatch(closeDialog("move-folder"));
  }, [dispatch, loading]);

  const submit = useCallback(async () => {
    try {
      const parentId = !folder._id ? null : folder._id;
      setLoading(true);
      await updateFolder({
        id: folderId,
        parentId: parentId,
        name: folderData?.name,
        openAccess: folderData?.openAccess,
        users: folderData?.users,
      });
      toast.success("Successfully moved folder");
    } catch (error) {
      console.error(error);
      toast.error("Failed to move folder");
    }
    setLoading(false);
    close();
  }, [folderId, folder, folderData, close, setLoading, updateFolder]);

  return (
    <CardFooter className="tw-justify-end tw-gap-4">
      <Button variant="secondary" onClick={close}>
        Go back
      </Button>
      <Button onClick={submit} disabled={!folder.name}>
        {loading ? "Moving..." : "Move"}
      </Button>
    </CardFooter>
  );
};
